import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listAllWorkflows } from '../application/list-workflows'
import { allWorkflows$ } from '../store'
import { workflows as workflowsPort, notify } from '../wiring'

const useAllWorkflows = () => {
	const workflows = useSelector(allWorkflows$)

	const reload = useEffectEvent(async () => {
		const result = await listAllWorkflows(workflowsPort, notify)
		allWorkflows$.set(result)
	})

	useEffect(() => {
		reload()
	}, [])

	return { workflows, reload }
}

export { useAllWorkflows }
